// Of de ingelogde gebruiker beheerder is. De auth-context kent alleen de
// gebruikersnaam, dus dit vraagt GET /api/me eenmaal per gebruiker op.
// Zonder verbinding of bij een fout: geen beheerder (de server controleert
// het toch zelf).

import { useEffect, useState } from 'react';
import { useAuth } from '@rvdh/react-auth-context';
import { api, endpoints } from '../api/client.js';

const cache = new Map();

export default function useIsAdmin() {
    const { user } = useAuth();
    const username = typeof user === 'string' ? user : user?.username;
    const [isAdmin, setIsAdmin] = useState(() => cache.get(username) ?? false);

    useEffect(() => {
        if (!username) { return undefined; }
        if (cache.has(username)) { setIsAdmin(cache.get(username)); return undefined; }
        let alive = true;
        api.get(endpoints.me)
            .then((me) => {
                const value = Boolean(me?.is_admin);
                cache.set(username, value);
                if (alive) { setIsAdmin(value); }
            })
            .catch(() => { /* offline of verlopen: knop blijft weg */ });
        return () => { alive = false; };
    }, [username]);

    return isAdmin;
}
